
import React, { Component } from 'react';
import './App.css';
import FilteredList from './FilteredList';

const players = [
  {
    name: "Jos van Meurs",
    tag: "ViolentPanda",
    team: "Gale Force eSports",
    region: "EU",
    country: "Netherlands",
    avatar: "violentpanda.jpg",
    bg: null,
    earnings: 54489
  },
  {
    name: "Courant Alexandre",
    tag: "Kaydop",
    team: "Gale Force eSports",
    region: "EU",
    country: "France",
    avatar: "kaydop.jpg",
    bg: null,
    earnings: 63972
  },
  {
    name: "Pierre Silfver",
    tag: "Turbopolsa",
    team: "Gale Force eSports",
    region: "EU",
    country: "Sweden",
    avatar: "turbopolsa.jpg",
    bg: null,
    earnings: 43352
  },
  {
    name: "Mariano Arruda",
    tag: "SquishyMuffinz",
    team: "Cloud9",
    region: "NA",
    country: "Canada",
    avatar: "squishy.jpg",
    bg: null,
    earnings: 23293
  },
  {
    name: "Kyle Storer",
    tag: "Torment",
    team: "Cloud9",
    region: "NA",
    country: "United States",
    avatar: "torment.jpg",
    bg: null,
    earnings: 27797
  },
  {
    name: "Jesus Parra",
    tag: "Gimmick",
    team: "Cloud9",
    region: "NA",
    country: "United States",
    avatar: "gimmick.jpg",
    bg: null,
    earnings: 18640
  },
  {
    name: "Linus Möllergren",
    tag: "Al0t",
    team: "Method",
    region: "EU",
    country: "Sweden",
    avatar: "al0t.jpg",
    bg: null,
    earnings: 13275
  },
  {
    name: "Joonas Salo",
    tag: "Mognus",
    team: "Method",
    region: "EU",
    country: "Finland",
    avatar: "mognus.jpg",
    bg: null,
    earnings: 19556
  },
  {
    name: "Otto Kaipiainen",
    tag: "Metsanauris",
    team: "Method",
    region: "EU",
    country: "Finland",
    avatar: "metsanauris.jpg",
    bg: null,
    earnings: 19761
  },
  {
    name: "Treyven Robitaille",
    tag: "Lethamyr",
    team: "Ghost Gaming",
    region: "NA",
    country: "Canada",
    avatar: "lethamyr.jpg",
    bg: null,
    earnings: 14014
  },
  {
    name: "Jason Klass",
    tag: "Klassux",
    team: "Ghost Gaming",
    region: "NA",
    country: "United States",
    avatar: "klassux.jpg",
    bg: null,
    earnings: 16988
  },
  {
    name: "Christopher Jacobs",
    tag: "Zanejackey",
    team: "Ghost Gaming",
    region: "NA",
    country: "United States",
    avatar: "zanejackey.jpg",
    bg: null,
    earnings: 13910
  },
  {
    name: "Philip Paschmeyer",
    tag: "Paschy90",
    team: "Mock-It eSports",
    region: "EU",
    country: "Germany",
    avatar: "paschy90.jpg",
    bg: null,
    earnings: 30497
  },
  {
    name: "Sandro Holzwarth",
    tag: "FreaKii",
    team: "Mock-It eSports",
    region: "EU",
    country: "Germany",
    avatar: "freakii.jpg",
    bg: null,
    earnings: 8079
  },
  {
    name: "Victor Locquet",
    tag: "Fairy Peak",
    team: "Mock-It eSports",
    region: "EU",
    country: "France",
    avatar: "fairy_peak.jpg",
    bg: null,
    earnings: 29829
  },
  {
    name: "Jacob McDowell",
    tag: "Jacob",
    team: "NRG Esports",
    region: "NA",
    country: "United States",
    avatar: "jacob.jpg",
    bg: null,
    earnings: 41868
  },
  {
    name: "Jayson Nunez",
    tag: "Fireburner",
    team: "NRG Esports",
    region: "NA",
    country: "United States",
    avatar: "fireburner.jpg",
    bg: null,
    earnings: 40212
  },
  {
    name: "Garrett Gordon",
    tag: "GarrettG",
    team: "NRG Esports",
    region: "NA",
    country: "United States",
    avatar: "garretg.jpg",
    bg: null,
    earnings: 41386
  },
  {
    name: "Victor Francal",
    tag: "Ferra",
    team: "PSG eSports",
    region: "EU",
    country: "France",
    avatar: "ferra.jpg",
    bg: null,
    earnings: 12499
  },
  {
    name: "Thibault Grzesiak",
    tag: "Chausette45",
    team: "PSG eSports",
    region: "EU",
    country: "France",
    avatar: "chausette45.jpg",
    bg: null,
    earnings: 11301
  },
  {
    name: "Dan Bluett",
    tag: "Bluey",
    team: "PSG eSports",
    region: "EU",
    country: "England",
    avatar: "bluey.jpg",
    bg: null,
    earnings: 11176
  },
  {
    name: "Cameron Bills",
    tag: "Kronovi",
    team: "G2 Esports",
    region: "NA",
    country: "United States",
    avatar: "kronovi.jpg",
    bg: null,
    earnings: 31915
  },
  {
    name: "Dillon Rizzo",
    tag: "Rizzo",
    team: "G2 Esports",
    region: "NA",
    country: "United States",
    avatar: "rizzo.jpg",
    bg: null,
    earnings: 18930
  },
  {
    name: "Jacob Knapman",
    tag: "JKnaps",
    team: "G2 Esports",
    region: "NA",
    country: "Canada",
    avatar: "jknaps.jpg",
    bg: null,
    earnings: 16609
  },
  {
    name: "Jake Edwards",
    tag: "Jake the Tyrant",
    team: "Chiefs eSports Club",
    region: "AU",
    country: "Australia",
    avatar: "jake_the_tyrant.jpg",
    bg: null,
    earnings: 12278
  },
  {
    name: "Matthew Den-Kaat",
    tag: "Drippay",
    team: "Chiefs eSports Club",
    region: "AU",
    country: "Australia",
    avatar: "drippay.jpg",
    bg: null,
    earnings: 12910
  },
  {
    name: "Daniel Parsons",
    tag: "Torsos",
    team: "Chiefs eSports Club",
    region: "AU",
    country: "Australia",
    avatar: "torsos.jpg",
    bg: null,
    earnings: 12873
  },
  {
    name: "Cameron Ingram",
    tag: "Kamii",
    team: "Pale Horse eSports",
    region: "AU",
    country: "New Zealand",
    avatar: "kamii.jpg",
    bg: null,
    earnings: 3365
  },
  {
    name: "Alex McDonald",
    tag: "Kia",
    team: "Pale Horse eSports",
    region: "AU",
    country: "Australia",
    avatar: "kia.jpg",
    bg: null,
    earnings: 3190
  },
  {
    name: "Cameron Johns",
    tag: "CJCJ",
    team: "Pale Horse eSports",
    region: "AU",
    country: "Australia",
    avatar: "cjcj.jpg",
    bg: null,
    earnings: 3190
  },
];

const teams = {
    "Cloud9": "c9.jpg",
    "Gale Force eSports": "gale_force.jpg",
    "Method": "method.jpg",
    "Ghost Gaming": "ghost.jpg",
    "Mock-It eSports": "mockit.jpg",
    "NRG Esports": "nrg.jpg",
    "PSG eSports": "psg.jpg",
    "G2 Esports": "g2.jpg",
    "Chiefs eSports Club": "chiefs.jpg",
    "Pale Horse eSports": "pale_horse.jpg"
};

const filters = [
  {
    title: "All Regions",
    key: "region",
    options: [
      {
        key: "all",
        name: "All Regions",
        filter: item => true,
      },
      {
        key: "na",
        name: "North America",
        filter: item => item.region === "NA"
      },
      {
        key: "eu",
        name: "Europe",
        filter: item => item.region === "EU"
      },
      {
        key: "au",
        name: "Australia",
        filter: item => item.region === "AU"
      }
    ]
  },
  {
    title: "All Countries",
    key: "country",
    options: [{
      key: "all",
      name: "All Countries",
      filter: item => true
    }].concat(
      Array.from(
        players.reduce((set, players) => {
          return set.add(players.country);
        }, new Set())
      ).sort().map(country => {
        return {
          key: country.toLowerCase().replace(/\s/g, ""),
          name: country,
          filter: item => item.country === country
        };
      })
    )
  },
  {
    title: "All Teams",
    key: "team",
    options: [{
      key: "all",
      name: "All Teams",
      filter: item => true
    }].concat(
      Array.from(
        players.reduce((set, players) => {
          return set.add(players.team);
        }, new Set())
      ).sort().map(team => {
        return {
          key: team.toLowerCase().replace(/\s/g, ""),
          name: team,
          filter: item => item.team === team
        };
      })
    )
  }
]

const sorters = [
  {
    key: "team",
    name: "Teams: A-Z",
    sort: (a, b) => a.team.localeCompare(b.team)
  },
  {
    key: "nameAZ",
    name: "Names: A-Z",
    sort: (a, b) => a.name.localeCompare(b.name)
  },
  {
    key: "tagAZ",
    name: "Username: A-Z",
    sort: (a, b) => a.tag.localeCompare(b.tag)
  },
  {
    key: "earningsHigh",
    name: "Earnings: High to Low",
    sort: (a, b) => b.earnings - a.earnings
  },
  {
    key: "earningsLow",
    name: "Earnings: Low to High",
    sort: (a, b) => a.earnings - b.earnings
  },
  {
    key: "country",
    name: "Countries: A-Z",
    sort: (a, b) => a.country.localeCompare(b.country)
  }
]

players.forEach(player => {
  player.bg = teams[player.team]
});

class App extends Component {
  render() {
    return (
      <div className="App">
        <FilteredList items={players} filters={filters} sorters={sorters} />
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js